import React from 'react';
import {useParams} from 'react-router-dom';
import {Message, Segment} from 'semantic-ui-react';
import {isEmpty as _isEmpty} from 'lodash';

import Authorization from '@appComponents/Authorization';
import {EVENT} from '@constants/resources';
import {SECURITY_PRIVILEGES_READ} from '@constants/variables';
import {GetEventSpiideoScheduling} from '@graphql/spiideo/query';
import SpiideoReconciliationHistory from '@modules/events/components/SpiideoReconciliationHistory';
import EventsStaticContentPanel from '@modules/events/components/EventsStaticContentPanel';
import {SpiideoSubpartsContent} from '@modules/events/components/SpiideoSubpartsContent';
import useQueryCustom from '@utils/hooks/useQueryCustom';

const SpiideoScheduling = () => {
    const {id: eventId} = useParams();

    const {data, loading} = useQueryCustom({
        query: GetEventSpiideoScheduling,
        options: {variables: {eventId}},
    });

    const spiideoEvent = data?.spiideoEvent;
    const attempts = data?.spiideoReconciliationAttempts ?? [];

    return (
        <Segment basic loading={loading}>
            <Authorization authorization={{[EVENT]: SECURITY_PRIVILEGES_READ}}>
                {!loading && !spiideoEvent && _isEmpty(attempts) ? (
                    <div className='table-container'>
                        <Message>
                            <Message.Header>
                                No Spiideo scheduling data for this event yet.
                            </Message.Header>
                        </Message>
                    </div>
                ) : null}

                {spiideoEvent || (!_isEmpty(attempts) && !loading) ? (
                    <EventsStaticContentPanel
                        id={`spiideo_game-${eventId}`}
                        title={spiideoEvent ? `Spiideo event (${spiideoEvent.id})` : 'Spiideo event'}
                    >
                        {spiideoEvent ? <SpiideoSubpartsContent data={spiideoEvent}/> : null}
                        <SpiideoReconciliationHistory attempts={attempts}/>
                    </EventsStaticContentPanel>
                ) : null}
            </Authorization>
        </Segment>
    );
};

export default SpiideoScheduling;
